export default {"src":"/_next/static/media/flag-ja.144b276b.svg","height":600,"width":900,"blurWidth":0,"blurHeight":0};